import { PLAN_CONFIGS, PlanId } from '@shared/types';
import { cn } from '@/lib/utils';

interface PlanQuotaPillProps {
  plan: typeof PLAN_CONFIGS[PlanId];
  size?: 'sm' | 'md';
  className?: string;
}

// Plain text — no pill chrome — in both sizes. The funnel's narrow plan
// cards stack the quotas on separate lines; the checkout's wider header
// renders them on a single row at a larger size to read as a real value
// statement, not a tiny detail.
export function PlanQuotaPill({ plan, size = 'md', className }: PlanQuotaPillProps) {
  if (size === 'sm') {
    return (
      <div
        className={cn(
          'w-full p-3 rounded-lg bg-white/5 border border-white/10',
          className,
        )}
      >
        <div className="flex justify-between text-sm mb-2">
          <span className="text-gray-400">Leads</span>
          <span className="text-white font-semibold tabular-nums">
            {plan.quotas.leadsLimit.toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-400">Websites</span>
          <span className="text-white font-semibold tabular-nums">
            {plan.quotas.sitesLimit.toLocaleString()}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('flex items-center justify-center gap-4', className)}>
      <span className="text-lg text-gray-200">
        <span className="font-bold text-white tabular-nums text-xl">
          {plan.quotas.leadsLimit.toLocaleString()}
        </span>{' '}
        <span className="text-gray-400">leads/mo</span>
      </span>
      <span className="w-px h-5 bg-white/15" />
      <span className="text-lg text-gray-200">
        <span className="font-bold text-white tabular-nums text-xl">
          {plan.quotas.sitesLimit.toLocaleString()}
        </span>{' '}
        <span className="text-gray-400">sites/mo</span>
      </span>
    </div>
  );
}
